export default __webpack_public_path__ + "71dc4dc87aa24d32e7c69b7e6fb3f92c.svg";